import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import RequestRecoverPassword from './pages/RequestRecoverPassword';
import ResetPassword from './pages/ResetPassword';
import 'bootstrap/dist/css/bootstrap.min.css';
import { routesConfig } from './config/routesConfig';
import { generateRoutes } from './utils/routeGenerator';

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        {/* Rutas generadas automáticamente desde la configuración */}
        {generateRoutes(routesConfig)}

        {/* Rutas públicas (sin autenticación) */}
        <Route path="/requestRecoverPassword" element={<RequestRecoverPassword />} />
        <Route path="/login" element={<Login />} />
        <Route path="/ResetPassword/:id" element={<ResetPassword />} />
      </Routes>
    </Router>
  </React.StrictMode>
); 